import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';
import './custom.scss';
import Home from './pages/Home/home';
import AboutUs from './pages/Home/aboutus';
import ContactUs from './pages/Home/contact';
import QIMeasures from './pages/Measures/qiresources';
import PQIMeasures from './pages/Measures/pqiresources';
import PSIMeasures from './pages/Measures/psiresources';
import PDIMeasures from './pages/Measures/pdiresources';
import PQISpec2021 from './components/Measures/TechnicalSpecifications/PQI/PQITechnical2021';
import PQISpec2020 from './components/Measures/TechnicalSpecifications/PQI/PQITechnical2020';
import PQISpec2019 from './components/Measures/TechnicalSpecifications/PQI/PQITechnical2019';
import PQISpec2018 from './components/Measures/TechnicalSpecifications/PQI/PQITechnical2018';
import PQISpec2017 from './components/Measures/TechnicalSpecifications/PQI/PQITechnical2017';
import PQISpec10v6 from './components/Measures/TechnicalSpecifications/PQI/PQITechnicalICD10v6';
import PQISpec9v6 from './components/Measures/TechnicalSpecifications/PQI/PQITechnicalICD9v6';
import PQISpec10v5 from './components/Measures/TechnicalSpecifications/PQI/PQITechnicalICD10v5';
import PQISpec9v5 from './components/Measures/TechnicalSpecifications/PQI/PQITechnicalICD9v5';
import PQISpec45 from './components/Measures/TechnicalSpecifications/PQI/PQITechnicalv45';
import PQISpec44 from './components/Measures/TechnicalSpecifications/PQI/PQITechnicalv44';
import PQISpec43a from './components/Measures/TechnicalSpecifications/PQI/PQITechnicalv43a';
import PQISpec43 from './components/Measures/TechnicalSpecifications/PQI/PQITechnicalv43';
import PQISpec42 from './components/Measures/TechnicalSpecifications/PQI/PQITechnicalv42';
import PQISpec41 from './components/Measures/TechnicalSpecifications/PQI/PQITechnicalv41';
import PDISpec2021 from './components/Measures/TechnicalSpecifications/PDI/PDITechnical2021';
import PDISpec2020 from './components/Measures/TechnicalSpecifications/PDI/PDITechnical2020';
import PDISpec2019 from './components/Measures/TechnicalSpecifications/PDI/PDITechnical2019';
import PDISpec2018 from './components/Measures/TechnicalSpecifications/PDI/PDITechnical2018';
import PDISpec2017 from './components/Measures/TechnicalSpecifications/PDI/PDITechnical2017';
import PDISpec10v6 from './components/Measures/TechnicalSpecifications/PDI/PDITechnicalICD10v6';
import PDISpec9v6 from './components/Measures/TechnicalSpecifications/PDI/PDITechnicalICD9v6';
import PDISpec10v5 from './components/Measures/TechnicalSpecifications/PDI/PDITechnicalICD10v5';
import PDISpec9v5 from './components/Measures/TechnicalSpecifications/PDI/PDITechnicalICD9v5';
import PDISpec45 from './components/Measures/TechnicalSpecifications/PDI/PDITechnicalv45';
import PDISpec44 from './components/Measures/TechnicalSpecifications/PDI/PDITechnicalv44';
import PDISpec43a from './components/Measures/TechnicalSpecifications/PDI/PDITechnicalv43a';
import PDISpec43 from './components/Measures/TechnicalSpecifications/PDI/PDITechnicalv43';
import PDISpec42 from './components/Measures/TechnicalSpecifications/PDI/PDITechnicalv42';
import PDISpec41 from './components/Measures/TechnicalSpecifications/PDI/PDITechnicalv41';
import PSISpec2021 from './components/Measures/TechnicalSpecifications/PSI/PSITechnical2021';
import PSISpec2020 from './components/Measures/TechnicalSpecifications/PSI/PSITechnical2020';
import PSISpec2019 from './components/Measures/TechnicalSpecifications/PSI/PSITechnical2019';
import PSISpec2018 from './components/Measures/TechnicalSpecifications/PSI/PSITechnical2018';
import PSISpec2017 from './components/Measures/TechnicalSpecifications/PSI/PSITechnical2017';
import PSISpec10v6 from './components/Measures/TechnicalSpecifications/PSI/PSITechnicalICD10v6';
import PSISpec9v6 from './components/Measures/TechnicalSpecifications/PSI/PSITechnicalICD9v6';
import PSISpec10v5 from './components/Measures/TechnicalSpecifications/PSI/PSITechnicalICD10v5';
import PSISpec9v5 from './components/Measures/TechnicalSpecifications/PSI/PSITechnicalICD9v5';
import PSISpec45a from './components/Measures/TechnicalSpecifications/PSI/PSITechnicalv45a';
import PSISpec45 from './components/Measures/TechnicalSpecifications/PSI/PSITechnicalv45';
import PSISpec44 from './components/Measures/TechnicalSpecifications/PSI/PSITechnicalv44';
import PSISpec43a from './components/Measures/TechnicalSpecifications/PSI/PSITechnicalv43a';
import PSISpec43 from './components/Measures/TechnicalSpecifications/PSI/PSITechnicalv43';
import PSISpec42 from './components/Measures/TechnicalSpecifications/PSI/PSITechnicalv42';
import PSISpec41 from './components/Measures/TechnicalSpecifications/PSI/PSITechnicalv41';
import IQISpec2021 from './components/Measures/TechnicalSpecifications/IQI/IQITechnical2021';
import IQISpec2020 from './components/Measures/TechnicalSpecifications/IQI/IQITechnical2020';
import IQISpec2019 from './components/Measures/TechnicalSpecifications/IQI/IQITechnical2019';
import IQISpec2018 from './components/Measures/TechnicalSpecifications/IQI/IQITechnical2018';
import IQISpec2017 from './components/Measures/TechnicalSpecifications/IQI/IQITechnical2017';
import IQISpec10v6 from './components/Measures/TechnicalSpecifications/IQI/IQITechnicalICD10v6';
import IQISpec9v6 from './components/Measures/TechnicalSpecifications/IQI/IQITechnicalICD9v6';
import IQISpec10v5 from './components/Measures/TechnicalSpecifications/IQI/IQITechnicalICD10v5';
import IQISpec9v5 from './components/Measures/TechnicalSpecifications/IQI/IQITechnicalICD9v5';
import IQISpec45 from './components/Measures/TechnicalSpecifications/IQI/IQITechnicalv45';
import IQISpec44 from './components/Measures/TechnicalSpecifications/IQI/IQITechnicalv44';
import IQISpec43a from './components/Measures/TechnicalSpecifications/IQI/IQITechnicalv43a';
import IQISpec43 from './components/Measures/TechnicalSpecifications/IQI/IQITechnicalv43';
import IQISpec42 from './components/Measures/TechnicalSpecifications/IQI/IQITechnicalv42';
import IQISpec41 from './components/Measures/TechnicalSpecifications/IQI/IQITechnicalv41';

import PDICodeLog from './pages/Measures/pdicodelog';
import PSICodeLog from './pages/Measures/psicodelog';
import PQICodeLog from './pages/Measures/pqicodelog';
import IQICodeLog from './pages/Measures/iqicodelog';
import NQF from './pages/Measures/nqf';
import IQIMeasures from './pages/Measures/iqiresources';
import AllMeasures from './pages/Measures/allmeasures';
import CompositeWorkgroups from './pages/Measures/compositeworkgroups';
import ArchivesQI from './pages/Archives/qimodules';
import ArchivesSoftware from './pages/Archives/software';
import ArchivesResources from './pages/Archives/resources';
import News from './pages/News/news';
import QI from './pages/Software/qi';
import QISoftwareV6 from './components/Software/QISoftwareV6ICD9';
import SASQI from './pages/Software/sasqi';
import ArchivesNews from './components/Archives/ArchivesNews';
import SASICD10 from './components/Software/SASICD10';
import SoftwareICD10 from './components/Software/SoftwareICD10Planning';
import WinQI from './pages/Software/winqi';
import FAQs from './pages/FAQs/faqs';
import Navigation from './components/Navigation/navbar';
import CaseStudies from './pages/Resources/casestudies';
import Webinars from './pages/Resources/webinars'
import Presentations from './pages/Resources/presentations';
import Publications from './pages/Resources/publications';
import Toolkits from './pages/Resources/toolkits';
import ScrollToTop from './ScrollToTop';
import Header from './components//Navigation/header';
import Footer from './components/Navigation/footer';
import ExitDisclaimer from './components/Other/ExitDisclaimer';
import MainLayout from './components/Layouts/MainLayout';

function App() {
  return (
    <Router>
      <>
        <Header />
        <Navigation />
        <ScrollToTop />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/home" exact component={Home} />
          <Route path="/home/about" component={AboutUs} />
          <Route path="/home/contact" component={ContactUs} />
          <Route path="/measures/" exact component={QIMeasures} />
          <Route path="/measures/qi_resources" component={QIMeasures} />
          <Route path="/measures/pdi_resources" component={PDIMeasures} />
          <Route path="/measures/pqi_resources" component={PQIMeasures} />
          <Route path="/measures/composite_workgroup" component={CompositeWorkgroups} />
          <Route path="/measures/Log_Coding_Updates_PDI_v2021" component={PDICodeLog} />
          <Route path="/measures/Log_Coding_Updates_PSI_v2021" component={PSICodeLog} />
          <Route path="/measures/Log_Coding_Updates_IQI_v2021" component={IQICodeLog} />
          <Route path="/measures/Log_Coding_Updates_PQI_v2021" component={PQICodeLog} />
          <Route path="/measures/list_ahrq_qi" component={NQF} />
          <Route path="/measures/psi_resources" component={PSIMeasures} />
          <Route path="/measures/iqi_resources" component={IQIMeasures} />
          <Route path="/measures/all_measures" component={AllMeasures} />
          <Route path="/resources/" exact component={Webinars} />
          <Route path="/resources/case_studies" component={CaseStudies} />
          <Route path="/resources/webinars" component={Webinars} />
          <Route path="/resources/presentations" component={Presentations} />
          <Route path="/resources/publications" component={Publications} />
          <Route path="/resources/toolkits" component={Toolkits} />
          <Route path="/faqs" component={FAQs} />
          <Route path="/software/" exact component={QI} />
          <Route path="/software/qi" component={QI} />
          <Route path="/software/WinQIv60ICD9" component={QISoftwareV6} />
          <Route path="/software/ICD10Planning" component={SoftwareICD10} />
          <Route path="/software/SASICD10" component={SASICD10} />
          <Route path="/software/sas_qi" component={SASQI} />
          <Route path="/software/win_qi" component={WinQI} />
          <Route path="/news" component={News} />
          <Route path="/archive" exact component={ArchivesQI} />
          <Route path="/archive/qi_modules" component={ArchivesQI} />
          <Route path="/archive/software" component={ArchivesSoftware} />
          <Route path="/archive/resources" component={ArchivesResources} />
          <Route path="/archive/news" component={ArchivesNews} />
          <Route path="/measures/PQI_TechSpec_ICD10_v2021" component={PQISpec2021} />
          <Route path="/archive/PQI_TechSpec_ICD10_v2020" component={PQISpec2020} />
          <Route path="/archive/PQI_TechSpec_ICD10_v2019" component={PQISpec2019} />
          <Route path="/archive/PQI_TechSpec_ICD10_v2018" component={PQISpec2018} />
          <Route path="/archive/PQI_TechSpec_ICD10_v70" component={PQISpec2017} />
          <Route path="/archive/PQI_TechSpec_ICD10_v60" component={PQISpec10v6} />
          <Route path="/archive/PQI_TechSpec_ICD10_v50" component={PQISpec10v5} />
          <Route path="/archive/PQI_TechSpec_ICD09_v60" component={PQISpec9v6} />
          <Route path="/archive/PQI_TechSpec_ICD9_v50" component={PQISpec9v5} />
          <Route path="/archive/PQI_TechSpec_V45" component={PQISpec45} />
          <Route path="/archive/PQI_TechSpec_V44" component={PQISpec44} />
          <Route path="/archive/PQI_TechSpec_V43a" component={PQISpec43a} />
          <Route path="/archive/PQI_TechSpec_V43" component={PQISpec43} />
          <Route path="/archive/PQI_TechSpec_V42" component={PQISpec42} />
          <Route path="/archive/PQI_TechSpec_V41" component={PQISpec41} />
          <Route path="/measures/PDI_TechSpec_ICD10_v2021" component={PDISpec2021} />
          <Route path="/archive/PDI_TechSpec_ICD10_v2020" component={PDISpec2020} />
          <Route path="/archive/PDI_TechSpec_ICD10_v2019" component={PDISpec2019} />
          <Route path="/archive/PDI_TechSpec_ICD10_v2018" component={PDISpec2018} />
          <Route path="/archive/PDI_TechSpec_ICD10_v70" component={PDISpec2017} />
          <Route path="/archive/PDI_TechSpec_ICD10_v60" component={PDISpec10v6} />
          <Route path="/archive/PDI_TechSpec_ICD10_v50" component={PDISpec10v5} />
          <Route path="/archive/PDI_TechSpec_ICD09_v60" component={PDISpec9v6} />
          <Route path="/archive/PDI_TechSpec_ICD9_v50" component={PDISpec9v5} />
          <Route path="/archive/PDI_TechSpec_V45" component={PDISpec45} />
          <Route path="/archive/PDI_TechSpec_V44" component={PDISpec44} />
          <Route path="/archive/PDI_TechSpec_V43a" component={PDISpec43a} />
          <Route path="/archive/PDI_TechSpec_V43" component={PDISpec43} />
          <Route path="/archive/PDI_TechSpec_V42" component={PDISpec42} />
          <Route path="/archive/PDI_TechSpec_V41" component={PDISpec41} />
          <Route path="/measures/PSI_TechSpec_ICD10_v2021" component={PSISpec2021} />
          <Route path="/archive/PSI_TechSpec_ICD10_v2020" component={PSISpec2020} />
          <Route path="/archive/PSI_TechSpec_ICD10_v2019" component={PSISpec2019} />
          <Route path="/archive/PSI_TechSpec_ICD10_v2018" component={PSISpec2018} />
          <Route path="/archive/PSI_TechSpec_ICD10_v70" component={PSISpec2017} />
          <Route path="/archive/PSI_TechSpec_ICD10_v60" component={PSISpec10v6} />
          <Route path="/archive/PSI_TechSpec_ICD10_v50" component={PSISpec10v5} />
          <Route path="/archive/PSI_TechSpec_ICD09_v60" component={PSISpec9v6} />
          <Route path="/archive/PSI_TechSpec_ICD9_v50" component={PSISpec9v5} />
          <Route path="/archive/PSI_TechSpec_V45a" component={PSISpec45a} />
          <Route path="/archive/PSI_TechSpec_V45" component={PSISpec45} />
          <Route path="/archive/PSI_TechSpec_V44" component={PSISpec44} />
          <Route path="/archive/PSI_TechSpec_V43a" component={PSISpec43a} />
          <Route path="/archive/PSI_TechSpec_V43" component={PSISpec43} />
          <Route path="/archive/PSI_TechSpec_V42" component={PSISpec42} />
          <Route path="/archive/PSI_TechSpec_V41" component={PSISpec41} />
          <Route path="/measures/IQI_TechSpec_ICD10_v2021" component={IQISpec2021} />
          <Route path="/archive/IQI_TechSpec_ICD10_v2020" component={IQISpec2020} />
          <Route path="/archive/IQI_TechSpec_ICD10_v2019" component={IQISpec2019} />
          <Route path="/archive/IQI_TechSpec_ICD10_v2018" component={IQISpec2018} />
          <Route path="/archive/IQI_TechSpec_ICD10_v70" component={IQISpec2017} />
          <Route path="/archive/IQI_TechSpec_ICD10_v60" component={IQISpec10v6} />
          <Route path="/archive/IQI_TechSpec_ICD10_v50" component={IQISpec10v5} />
          <Route path="/archive/IQI_TechSpec_ICD9_v60" component={IQISpec9v6} />
          <Route path="/archive/IQI_TechSpec_ICD9_v50" component={IQISpec9v5} />
          <Route path="/archive/IQI_TechSpec_V45" component={IQISpec45} />
          <Route path="/archive/IQI_TechSpec_V44" component={IQISpec44} />
          <Route path="/archive/IQI_TechSpec_V43a" component={IQISpec43a} />
          <Route path="/archive/IQI_TechSpec_V43" component={IQISpec43} />
          <Route path="/archive/IQI_TechSpec_V42" component={IQISpec42} />
          <Route path="/archive/IQI_TechSpec_V41" component={IQISpec41} />
          <Route path="/ExternalDisclaimer" exact component={ExitDisclaimer} />


        </Switch>
        <Footer />
      </>
    </Router>
  );
}

export default App;
